import { Injectable } from "@angular/core";
import * as moment from "moment";
import { PurchasesService } from "../purchases.service";
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { Status } from 'src/app/inventory/constants/constants';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { lastValueFrom } from "rxjs";
import { SalesOrderService } from "../../sales-order/sales-order.service";
import { SettingService } from "src/app/configurations/inventory/setting/setting.service";


@Injectable({
    providedIn: "root",
})
export class UtilsService {

    constructor(private purchaseService: PurchasesService, private addYearPipe: AddYearPipe,
        private settingService: SettingService, private salesOrderService: SalesOrderService
    ) { }

    setProductSerialDetails(serialDetails, app) {
        const tracking = [];
        serialDetails?.forEach(element => {
            const trackEach = {
                id: 0,
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderId: 0,
                billOrderProductId: 0,
                barcode: element.barcode,
                serialNumber2: element.serialNumber2,
                serialNumber3: element.serialNumber3,
                serialNumber4: element.serialNumber4,
                serialNumber5: element.serialNumber5,
                serialNumber6: element.serialNumber6,
                serialNumber7: element.serialNumber7,
                serialNumber8: element.serialNumber8,
                serialNumber9: element.serialNumber9,
                serialNumber10: element.serialNumber10,
                serialNumber11: element.serialNumber11,
                serialNumber12: element.serialNumber12,
                serialNumber13: element.serialNumber13,
                serialNumber14: element.serialNumber14,
                serialNumber15: element.serialNumber15,
                serialNumber16: element.serialNumber16,
                serialNumber17: element.serialNumber17,
                lotNumber: element.lotNumber,
                revisionNumber: element.revisionNumber,
                expirationDate: element.expirationDate,
                statusId: Status.Active
            }
            tracking.push(trackEach);
        });
        return tracking;
    }

    setBundleSerialDetails(trackings, app) {
        const tracking = [];
        trackings?.forEach(element => {
            const trackEach = {
                id: 0,
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderProductId: 0,
                billOrderBundleDetailId: 0,
                barcode: element.barcode,
                lotNumber: element.lotNumber,
                revisionNumber: element.revisionNumber,
                expirationDate: element.expirationDate,
                statusId: 1
            }
            tracking.push(trackEach);
        });
        return tracking;
    }

    setBundleProduct(bundleProducts, app) {
        const bundle = [];
        bundleProducts?.forEach(element => {
            const bundleEach = {
                id: 0,
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderId: 0,
                billOrderProductId: 0,
                billOrderProduct: '',
                productId: element.productId,
                purchaseOrderId: element.purchaseOrderId,
                purchaseOrderNo: element.purchaseOrderNo,
                subProductId: element.subProductId,
                productUnitId: element.productUnitId,
                quantity: element.quantity,
                pricePerProduct: element.pricePerProduct,
                totalAmount: element.totalAmount,
                binId: 0,
                statusId: 1,
                warehouseId: element.warehouseId,
                receivedAmount: element.receivedAmount,
                dueAmount: element.dueAmount,
                qtyReceived: 0,
                qtyPending: 0,
                billOrderBundleSerialDetail: this.setBundleSerialDetails(element.receivedPurchaseOrderBundleSerialDetail, app),
                isClosed: true,
                orderedQty: 0,
                discountTypeId: 0,
                discountAmount: 0,
                taxId: 0,
                taxTypeId: 0,
                taxRate: 0,
                description: '',
                isForceClosed: true,
                receivedProductStatus: '',
                totalQty: 0,
                discountId: 0,
                discountName: '',
                discountFinancialId: 0,
                taxFinancialId: 0,
                taxName: ''
            }
            bundle.push(bundleEach);
        });
        return bundle;
    }

    setBillProducts(prods, res, app) {
        const products = [];
        prods?.forEach(element => {
            const prodEach = {
                id: 0,
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderId: 0,
                productId: element.productId,
                productUnitId: element.productUnitId,
                quantity: element.quantity,
                pricePerProduct: Number(element.pricePerProduct) * Number(res.exchangeRate),
                totalAmount: Number(element.totalAmount) * Number(res.exchangeRate),
                netAmount: Number(element.netAmount) * Number(res.exchangeRate),
                purchaseOrderId: element.purchaseOrderId,
                purchaseOrderNo: element.purchaseOrderNo,
                binId: 0,
                statusId: 1,
                warehouseId: element.warehouseId,
                receivedAmount: Number(element.receivedAmount) * Number(res.exchangeRate),
                dueAmount: Number(element.dueAmount) * Number(res.exchangeRate),
                qtyReceived: 0,
                qtyPending: 0,
                billOrderBundleDetail: this.setBundleProduct(element.receivedPurchaseBundleDetail, app),
                billOrderSerialDetail: this.setProductSerialDetails(element.receivedPurchaseOrderSerialDetail, app),
                isClosed: true,
                orderedQty: element.orderedQty,
                discountTypeId: 0,
                discountAmount: 0,
                taxId: 0,
                taxTypeId: 0,
                taxRate: 0,
                description: element.description,
                isForceClosed: true,
                receivedProductStatus: '',
                totalQty: element.totalQty,
                discountId: 0,
                discountName: '',
                discountFinancialId: 0,
                taxFinancialId: 0,
                taxName: '',
                billOrderProductSubTax: this.setBillConvertProductSubTax(element, res)
            }
            products.push(prodEach);
        });
        return products;
    }

    calculateFromDate(days) {
        const date = new Date();
        const last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
        const dd = last.getDate();
        const mm = last.getMonth() + 1;
        const yyyy = last.getFullYear();
        const previousDate = mm + '/' + dd + '/' + yyyy;
        return previousDate;
    }

    setNormalDate(date) {
        const today = date;
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();
        const todayFullDate = mm + '/' + dd + '/' + yyyy;
        return todayFullDate;
    }

    setNotes(value, app) {
        const note: any[] = [];
        if (value) {
            const notes = {
                id: 0,
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                billOrderId: 0,
                userId: (value.userId ? value.userId : 0),
                noteId: 0,
                note: {
                    id: 0,
                    createdSource: app.userIP,
                    updatedSource: app.userIP,
                    createdBy: app.userId,
                    updatedBy: app.userId,
                    createdDate: new Date().toISOString(),
                    updatedDate: new Date().toISOString(),
                    comment: value,
                    isImportant: true,
                    organizationId: app.companyId,
                    description: '',
                    statusId: Status.Active,
                    status: null,
                    isValid: true,
                    validFromDate: new Date().toISOString(),
                    validToDate: this.addYearPipe.transform(new Date()),
                    noteComments: null,
                    noteAttachments: null,
                    createdByName: ''
                },
                statusId: Status.Active,
                status: null
            }
            note.push(notes);
        }
        return note;
    }


    getDueDate(paymentTerm, date) {
        let result;
        if (paymentTerm?.type && paymentTerm?.type?.name == "NET") {
            if (paymentTerm?.netDueDay) {
                result = moment(new Date(date))
                    .add(paymentTerm?.netDueDay, "days")
                    .toDate();
            }
        } else if (paymentTerm?.type &&
            paymentTerm?.type?.name == "Date Driven"
        ) {
            const dateOfTheMonth = new Date(
                moment(date).year(),
                moment(date).month(),
                paymentTerm?.netDueDay
            );
            const firstDayOfThatMonth = new Date(
                moment(date).year(),
                moment(date).month(),
                1
            );

            const lastDueDateOfThatMonth = moment(
                new Date(dateOfTheMonth)
            ).subtract(paymentTerm?.nextMonthBeforeDue, "days");
            const isBeforeDueDate = moment(new Date(date)).isBetween(
                firstDayOfThatMonth,
                moment(lastDueDateOfThatMonth).add(1, "days").toDate()
            );
            if (isBeforeDueDate) {
                result = dateOfTheMonth;
            } else {
                result = moment(new Date(dateOfTheMonth))
                    .add(1, "months")
                    .toDate();
            }
        }
        return result;
    }

    deleteVoidBill(id, isvoid) {
        this.purchaseService.voidBill(id, isvoid).then(() => {
            return;
        }).catch(() => {
            return;
        });
    }

    isNumberKey(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    isDecimalNumberKey(evt, val) {
        const charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
            return false;
        else {
            var len = val.length;
            var index = val?.indexOf('.');
            if (index > 0 && charCode == 46) {
                return false;
            }
            if (index > 0) {
                var CharAfterdot = (len + 1) - index;
                if (CharAfterdot > 3) {
                    return false;
                }
            }

        }
        return true;
    }

    convertToBill(res, app) {
        const req = {
            id: 0,
            createdSource: app.userIP,
            updatedSource: app.userIP,
            createdBy: app.userId,
            updatedBy: app.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
            number: '',
            name: '',
            description: '',
            organizationId: app.companyId,
            userId: res.userId ?? 0,
            purchaseOrderId: 0,
            billDate: app._saveDateTimeWithZone(new Date()),
            receivedPurchaseOrderId: res?.id,
            warehouseId: res?.warehouseId,
            contactId: res?.contactId,
            shippingAddressId: res?.shippingAddressId,
            totalAmount: Number(res?.totalAmount) * Number(res.exchangeRate),
            totalExpenseAmount: 0,
            billAmount: Number(res.netAmount) * Number(res.exchangeRate),
            currencyUnitId: res.currencyUnitId,
            exchangeRate: res.exchangeRate ?? 0,
            discountTypeId: (res?.discountTypeId ?? 0),
            discountAmount: Number(res?.discountAmount) * Number(res.exchangeRate),
            shippingChargeAmount: Number(res?.shippingChargeAmount) * Number(res.exchangeRate),
            taxId: 0,
            taxTypeId: 0,
            taxAmount: Number(res?.taxAmount) * Number(res.exchangeRate),
            otherChargeAmount: 0,
            netAmount: Number(res.netAmount) * Number(res.exchangeRate),
            purchaseOrderStageId: 0,
            purchaseOrderStage: '',
            paymentTermId: res?.paymentTermId,
            paymentMethodId: res?.paymentMethodId,
            shippingTermId: res?.shippingTermId,
            shippingMethodId: res?.shippingMethodId,
            statusId: Status.Active,
            isValid: true,
            validFromDate: new Date().toISOString(),
            validToDate: this.addYearPipe.transform(new Date()),
            billOrderProducts: this.setBillProducts(res?.receivedPurchaseOrderProducts, res, app),
            billOrderNotes: this.setNotes((res.receivedPurchaseOrderNotes?.length > 0 ? res.receivedPurchaseOrderNotes[0].note.comment : ''), app),
            billOrderExpense: null,
            vendorBusinessName: res?.vendorBusinessName,
            receivedPurchaseOrderStatus: '',
            createdByUser: res?.createdByUser,
            isConverted: true,
            vendorId: res.vendorId,
            dueDate: (this.getDueDate(res?.paymentTerm, res?.purchaseOrder?.poDate) ?? app._saveDateTimeWithZone(new Date())),
            configJson: '',
            referenceNo: res?.referenceNo
        }
        return req;
    }

    generateSerialNo(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    autogenerateSerial(value, prefixValue, nameLists, length) {
        for (let i = 0; i < value.qty; i++) {
            value.serialNo = prefixValue.concat(this.generateSerialNo(12 - prefixValue?.length));
            nameLists.push({ ...value });
        }
        return nameLists;
    }

    checkforBulkImportPurchase(products) {
        for (let prd of products) {
            if (prd.trackingEnabled) {
                return true;
            }
            for (let bundle of prd.products) {
                if (bundle.trackingEnabled) {
                    return true;
                }
            }
        }
        return false;
    }

    checkSerialNoValidationRPO(receivePurchaseListTB) {
        for (let s of receivePurchaseListTB) {
            if (s.quantityReceive < (s.ReceivedPurchaseOrderSerialDetail ? s.ReceivedPurchaseOrderSerialDetail?.length : s.serialCount)) {
                return false;
            }
            if (s.products?.length > 0) {
                for (let prd of s.products) {
                    if (prd.quantityReceive < (prd.receivedPurchaseOrderBundleSerialDetail ? prd.receivedPurchaseOrderBundleSerialDetail?.length : prd.serialCount)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    checkSerialNoValidationBill(items) {
        for (let s of items) {
            if (s.availabel < (s.billOrderSerialDetail ? s.billOrderSerialDetail?.length : s.serialCount)) {
                return false;
            }
            if (s.products?.length > 0) {
                for (let prd of s.products) {
                    if (prd.availabel < (prd.billOrderBundleSerialDetail ? prd.billOrderBundleSerialDetail?.length : prd.serialCount)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    showTrackingOption(trackingOptions: any[], option: string, savedOption: any): boolean {
        if (savedOption) {
            if (savedOption[`${option}`]) {
                return trackingOptions?.some(track => track.code === option && track.enabled);
            } else {
                return false;
            }
        } else {
            return trackingOptions?.some(track => track.code === option && track.enabled);
        }
    }

    hasSerialNo(serialNo, systemTrackingData) {
        if (serialNo) {
            return systemTrackingData?.findIndex(sNo => sNo.serialNo == serialNo) == -1
        } else {
            return 1;
        }
    }

    displayName(code, trackingOptions, type) {
        if (type === 'label') {
            return trackingOptions?.find(opt => opt.code == code)?.name;
        } else if (type === 'currency') {
            return trackingOptions?.find(opt => opt.code == code)?.currencySymbol;
        } else {
            return trackingOptions?.find(opt => opt.code == code)?.formControlName;
        }
    }

    checkRequiredValidation(code, trackingOptions) {
        return trackingOptions?.find((el) => el.code === code)?.isRequired || false;
    }

    getDecimalValue(trackingOptions: any[], code) {
        return trackingOptions?.find(opt => opt.code == code)?.noOfDecimal;
    }

    isCountCategory(uomCategory: any[], categoryId: number): boolean {
        if (!Array.isArray(uomCategory) || uomCategory.length === 0) {
            return false;
        }
        const countCategoryExists = uomCategory.find(ct => ct.name === 'Count');
        return countCategoryExists && (countCategoryExists.id === categoryId);
    }

    hasRequiredValidator(formGroup: FormGroup): boolean {
        return Object.keys(formGroup.controls).some(controlName => {
            if (controlName != 'qty') {
                const control = formGroup.get(controlName);
                if (control?.validator) {
                    const validatorFn = control.validator({} as AbstractControl);
                    return validatorFn?.required;
                }
                return false;
            }
        });
    }

    // Custom validator function
    atLeastOneFieldValidator(fields: string[]): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const isValid = fields.some(field => {
                const value = formGroup.get(field)?.value;
                // Skip date objects
                if (value instanceof Date) {
                    return false;
                }
                // Handle string values
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }
                // Handle other non-null values (like numbers, booleans)
                return value != null && value !== '';
            });
            return isValid ? null : { atLeastOneRequired: true };
        };
    }

    calculateProductsTax(taxRate: number, subTotal: number) {
        return subTotal * (Number(taxRate) / 100);
    }

    /** Fetch Tax Settings */
    async getTaxByCountryId(countryId: number) {
        const iSettings = await lastValueFrom(this.settingService.getAllInventorySettings());
        const taxSettings = iSettings?.find((s) => s?.code?.toLowerCase() == "tax")?.childInventorySettings;
        let allTaxRates = await lastValueFrom(this.salesOrderService.getTaxByAddress(countryId));
        let tax = await lastValueFrom(this.salesOrderService.getAllTax());
        const taxConfig = tax?.item2 && tax?.item2?.length > 0 ? tax?.item2 : [];

        if (!allTaxRates) {
            allTaxRates = [];
            if (taxConfig && taxConfig.length > 0) {
                taxConfig?.forEach((tc) => {
                    let tax = tc?.tax?.find((t) => t.isDefault && t.statusId == Status.Active);
                    if (tax) {
                        allTaxRates.push(tax);
                    }
                });
            }
        }
        return { taxSettings: taxSettings, allTaxRates: allTaxRates, taxConfig: taxConfig };
    }

    getTaxId(tax: any, productId: number, module: string, rpoDetail: any) {
        if (module == 'rpo') {
            return rpoDetail?.receivedPurchaseOrderProducts?.find(item => item.productId == productId)?.receivedPOProductSubTax?.find(sTax => sTax.taxId == tax.taxId)?.id ?? 0;
        } else {
            return rpoDetail?.billOrderProducts?.find(item => item.productId == productId)?.billOrderProductSubTax?.find(sTax => sTax.taxId == tax.taxId)?.id ?? 0;
        }
    }

    setProductSubTax(product, allTaxRates, app,ordersVendorCountryNew, ordersVendorStateNew, shipAddress, rpoDetail?) {
        return product.productSubTax?.map(tax => {
            tax.country = tax.country ?? allTaxRates?.find(t => t.id == tax.taxId)?.country;
            const baseTaxAmount = this.calculateProductsTax(tax.taxRate, product.pricePerProduct);
            const isIndia = tax.country === 'India';
            const isSameState = this.checkSameState(ordersVendorCountryNew, ordersVendorStateNew, shipAddress);
            const halfTax = (isIndia && isSameState) ? (product.quantityReceive * baseTaxAmount) / 2 : 0;
            return {
                receivedPurchaseOrderProductId: product.receivedPurchaseOrderProductId ?? 0,
                taxId: tax.taxId,
                taxRate: tax.taxRate,
                taxAmount: product.quantityReceive * baseTaxAmount,
                cgst: halfTax,
                igst: (isIndia && !isSameState) ? product.quantityReceive * baseTaxAmount : 0,
                sgst: halfTax,
                statusId: Status.Active,
                taxFinancialId: tax.financialAccountId,
                taxName: tax.name,
                id: this.getTaxId(tax, product.productId, 'rpo', rpoDetail),
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString()
            };
        });
    }

    setBillConvertProductSubTax(product, res) {
        return product.receivedPOProductSubTax?.map(tax => {
            return {
                billOrderProductId: 0,
                taxId: tax.taxId,
                taxRate: tax.taxRate,
                taxAmount: (tax.taxAmount) * Number(res.exchangeRate),
                cgst: (tax.cgst * Number(res.exchangeRate)),
                igst: (tax.igst * Number(res.exchangeRate)),
                sgst: (tax.sgst * Number(res.exchangeRate)),
                statusId: Status.Active,
                taxFinancialId: tax.financialAccountId,
                taxName: tax.name,
                id: 0,
                createdSource: tax.createdSource,
                updatedSource: tax.updatedSource,
                createdBy: tax.createdBy,
                updatedBy: tax.updatedBy,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString()
            };
        });
    }

    checkSameState(ordersVendorCountryNew, ordersVendorStateNew, shipAddress) {
        if (ordersVendorCountryNew.toLocaleLowerCase() == shipAddress?.address?.country?.name?.toLowerCase()
            && ordersVendorStateNew?.toLowerCase() == shipAddress?.address?.state?.name?.toLowerCase()) {
            return true;
        }
        return false;
    }

    setInvBillProductSubTax(product, allTaxRates, app,ordersVendorCountryNew, ordersVendorStateNew, shipAddress, billDetail?) {
        return product.productSubTax?.map(tax => {
            tax.country = tax.country ?? allTaxRates?.find(t => t.id == tax.taxId)?.country;
            const baseTaxAmount = this.calculateProductsTax(tax.taxRate, product.price);
            const isIndia = tax.country === 'India';
            const isSameState = this.checkSameState(ordersVendorCountryNew, ordersVendorStateNew, shipAddress);
            const halfTax = (isIndia && isSameState) ? (product.availabel * baseTaxAmount) / 2 : 0;
            return {
                billOrderProductId: product.billOrderProductId ?? 0,
                taxId: tax.taxId,
                taxRate: tax.taxRate,
                taxAmount: product.availabel * baseTaxAmount,
                cgst: halfTax,
                igst: (isIndia && !isSameState) ? product.availabel * baseTaxAmount : 0,
                sgst: halfTax,
                statusId: Status.Active,
                taxFinancialId: tax.financialAccountId,
                taxName: tax.name,
                id: this.getTaxId(tax, product.productId, 'bill', billDetail),
                createdSource: app.userIP,
                updatedSource: app.userIP,
                createdBy: app.userId,
                updatedBy: app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString()
            };
        });
    }
}
